import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	filterRow: {
		alignItems: 'flex-end',
	},
	boardPicker: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		minWidth: 280,
	},
	label: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
	},
	select: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		fontSize: THEME.typography.fontSizes.sm,
		background: THEME.colors.background.light,
	},
	checkboxLabel: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		height: 36,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	errorNote: {
		marginTop: THEME.spacing.sm,
		color: THEME.colors.danger.dark,
		fontSize: THEME.typography.fontSizes.sm,
	},
	reportFilters: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.md,
		marginTop: THEME.spacing.md,
		alignItems: 'flex-end',
	},
	clearReportFilters: {},
	reportFilterField: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	ownerFilterContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		maxWidth: '100%',
	},
	ownerFilterRow: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: 0,
		alignItems: 'flex-end',
		width: '100%',
	},
	ownerScopeField: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		alignItems: 'flex-start',
		flexGrow: 0,
		flexShrink: 0,
	},
	ownerScopeFieldSpecific: {
		...CssSelectors.allChildren(
			{
				borderTopRightRadius: 0,
				borderBottomRightRadius: 0,
			},
			'button'
		),
	},
	ownerComboboxWrap: {
		flex: '1 1 0',
		minWidth: 320,
		maxWidth: 560,
		...CssSelectors.allChildren(
			{
				borderTopLeftRadius: 0,
				borderBottomLeftRadius: 0,
			},
			'[data-slot="input-group"]'
		),
	},
	ownerComboboxInput: {
		width: '100%',
	},
	dateRangePair: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
		alignItems: 'flex-end',
	},
	dateInput: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		fontSize: THEME.typography.fontSizes.sm,
		background: THEME.colors.background.light,
	},
	/** Use when sibling by-owner chart is hidden so this row isn’t half-width empty. */
	chartGridFullWidth: {
		gridColumn: 'span 12 !important',
	},
});
